namespace $.$$ {
	/**
	 * @see https://mol.hyoo.ru/#!section=demos/demo=mol_toolbar_demo
	 */
	export class $mol_toolbar extends $.$mol_toolbar {

	}
}
